import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/agreements`
  : 'https://backend-c-0mxm.onrender.com/api/agreements';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response) {
    return { message: error.response.data.message || 'Có lỗi xảy ra', status: error.response.status };
  }
  return { message: 'Không thể kết nối đến server', status: 0 };
};

// User endpoints
export const getPendingAgreements = async () => {
  try {
    const response = await api.get('/pending');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const getMyAgreements = async () => {
  try {
    const response = await api.get('/my');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const acceptAgreement = async (id) => {
  try {
    const response = await api.post(`/${id}/accept`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Admin endpoints
export const getAllAgreements = async () => {
  try {
    const response = await api.get('/admin/all');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const createAgreement = async (formData) => {
  try {
    const response = await api.post('/admin/create', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const updateAgreement = async (id, formData) => {
  try {
    const response = await api.put(`/admin/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const deleteAgreement = async (id) => {
  try {
    const response = await api.delete(`/admin/${id}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};
